import axios from 'axios'
import React, { useEffect, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import Modal from 'react-bootstrap/Modal';
import certificateImage from "../../images/WarrantyCertificate.png"
import DownloadIcon from '@mui/icons-material/Download';
import Barcode from "react-barcode";
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
function AddWarrantyCard({ serverUrl, user, globalUserId, globalToken  }) {
    const [currentData, setCurrentsData] = useState([]);
    const [usedBarcodes, setUsedBarCodes] = useState([]);

    const [patientName, setPatientName] = useState("");
    const [patientEmail, setPatientEmail] = useState("");
    const [patientMobile, setPatientMobile] = useState("");
    const [patientAddress, setPatientAddress] = useState("");

    const [dentistName, setDentistName] = useState("");
    const [dentistEmail, setDentistEmail] = useState("");
    const [dentistAddress, setDentistAddress] = useState("");
    const [dentistMobile, setDentistMobile] = useState("");

    const [yearOfWarranty, setYearOfWarranty] = useState("")

    const [productName, setProductName] = useState("DD Bio ZX2-10 Year")

    const [issueDate, setIssueDate] = useState("");

    const [shadeDescription, setShadeDescription] = useState("");

    const [quantity, setQuantity] = useState("");

    const [labCaseNumber, setLabCaseNumber] = useState("");

    const [labCaseDescription, setLabCaseDescrition] = useState("");

    const [ddCaseNumber, setDDCaseNumber] = useState("");

    const [codeToSearch, setCodeToSearch] = useState("");

    const [showWarrantyCertificate, setShowWarrantyCertificate] = useState(false)

    const [verificationCode, setVerificationCode] = useState("");

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }

    const getDetailsAboutWarranty = async () => {
        const query = { code: codeToSearch }

        const getData = await axios.post(serverUrl + "/barcodes/find", query)
        if (getData.status == 200) {
            const availableCards = getData.data.filter((barcode) => { return barcode.status === "Market_Printing_Out" });
            if (availableCards.length > 0) {
                setVerificationCode(availableCards[0].verificationCode)
                setYearOfWarranty(availableCards[0].validityYear)
                setIssueDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().split(".")[0])
                console.log(getData.data[0])

                getUsedBarcodes()
            } else {
                alert("Warranty Card Not Available")
            }
        } else {
            alert("Something went wrong while getting this card.")
            console.log(getData.data)
        }
    }

    const getUsedBarcodes = async () => {
        const query = { userId: user.userId }

        const getData = await axios.post(serverUrl + "/barcodes/findByUser", query)
        if (getData.status == 200) {
            setDDCaseNumber(user.userId + "-" + (getData.data?.length + 1).toString().padStart(4, "0"))
            console.log(getData.data)
        } else {
            console.log(getData.data)
        }
    }

    const generateWarrantyCard = async (e) => {
        e.preventDefault();

        const query = {
            "warrantyNumber": codeToSearch,
            "yearOfWarranty": yearOfWarranty,
            "verificationCode": verificationCode,
            "issueDate": new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().split(".")[0],
            "ddCaseNumber": ddCaseNumber,
            "productName": productName,
            "shadeDescription": shadeDescription,
            "quantity": quantity,
            "userId": user.userId,
            "labCaseNumber": labCaseNumber,
            "labCaseDescription": labCaseDescription,
            "dentistName": dentistName,
            "dentistEmail": dentistEmail,
            "dentistAddress": dentistAddress,
            "dentistMobile": dentistMobile,
            "patientName": patientName,
            "patientEmail": patientEmail,
            "patientMobile": patientMobile,
            "patientAddress": patientAddress,
            "status": "Issued",
            "settings": {}
        }

        console.log(query)

        const generateWarrantyCard = await axios.post(serverUrl + "/warrantyCards/add", query);

        if (generateWarrantyCard.status === 200) {
            setShowWarrantyCertificate(true);
            console.log(generateWarrantyCard.data)
        } else {
            alert(generateWarrantyCard.data)
            console.log(generateWarrantyCard.data)
        }

    }

    const resetAllFields = () => {
        setPatientName("")
        setPatientEmail("")
        setPatientMobile("")
        setPatientAddress("")
        setDentistName("")
        setDentistEmail("")
        setDentistAddress("")
        setDentistMobile("")
        setYearOfWarranty("")
        setProductName("DD Bio ZX2-10 Year")
        setIssueDate("")
        setShadeDescription("")
        setQuantity("")
        setLabCaseNumber("")
        setLabCaseDescrition("")
        setDDCaseNumber("")
        setCodeToSearch("")
    }

    useEffect(() => {
        getUsedBarcodes()
    }, [])
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>Add Warranty Card</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto rounded-0 h-100'>
                    <div className="container-fluid mb-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12">
                                            <form action="" onSubmit={(e) => { e.preventDefault(); getDetailsAboutWarranty() }}>
                                                <label htmlFor="codeToSearch" className="text-dark m-0 p-0 d-flex flex-column">
                                                    Search Number
                                                </label>
                                                <div className="div d-flex align-items-center justify-content-start">
                                                    <input id="codeToSearch" type="text" required className='customFieldForDence w-100' placeholder="Search Number" value={codeToSearch} onInput={(e) => { setCodeToSearch(e.target.value); }} style={{ maxWidth: "300px" }} />
                                                    <button className='themeButtons rounded px-3 py-1'>
                                                        <SearchIcon />
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form action="" className='d-flex' onSubmit={(e) => { e.preventDefault(); generateWarrantyCard(e); }}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Warranty Number</div>
                                            <div className="col-8 col-sm-9">
                                                <input type="text" required className='customFieldForDence w-100' readOnly value={codeToSearch} onInput={(e) => { }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Year of Warranty</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required readOnly value={yearOfWarranty} onInput={(e) => { setYearOfWarranty(e.target.value) }} className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Issue Date</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="datetime-local" required value={issueDate} onChange={(e) => { setIssueDate(new Date().toISOString().split(".")[0]) }} className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">DD Case number</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required value={ddCaseNumber} onInput={(e) => { setDDCaseNumber(e.target.value) }} readOnly={true} className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Product Name</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <select name="" id="" className='customFieldForDence' onInput={(e) => { setProductName(e.target.value) }} style={{ maxWidth: "300px" }}>
                                                    <option value="DD Bio ZX2-10 Year">DD Bio ZX2-10 Year</option>
                                                    <option value="DD Cube X2-12 Year">DD Cube X2-12 Year</option>
                                                    <option value="DD Bio Zw-20 Year">DD Bio Zw-20 Year</option>
                                                    <option value="DD Cube One 15 Year">DD Cube One 15 Year</option>

                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Shade Desctription</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required className='customFieldForDence w-100' value={shadeDescription} onInput={(e) => { setShadeDescription(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Quantity</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="number" required className='customFieldForDence w-100' min={0} value={quantity} onInput={(e) => { setQuantity(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">User ID</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required readOnly={true} defaultValue={user.userId} className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Lab Case Number</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required className='customFieldForDence w-100' value={labCaseNumber} onInput={(e) => { setLabCaseNumber(e.target.value); }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Lab Case Description</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required className='customFieldForDence w-100' value={labCaseDescription} onInput={(e) => { setLabCaseDescrition(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 themeTextColor fs-5 my-3">
                                    Dentist Details
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Dentist Name*</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" required className='customFieldForDence w-100' value={dentistName} onInput={(e) => { setDentistName(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Dentist Email</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="email" className='customFieldForDence w-100' value={dentistEmail} onInput={(e) => { setDentistEmail(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Dentist Address</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <textarea required className='customFieldForDence w-100' value={dentistAddress} onInput={(e) => { setDentistAddress(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Dentist Mobile*</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="tel" required className='customFieldForDence w-100' value={dentistMobile} onInput={(e) => { setDentistMobile(e.target.value) }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 themeTextColor fs-5 my-3">
                                    Patient Details
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Patient Name</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="text" className='customFieldForDence w-100' value={patientName} onInput={(e) => { setPatientName(e.target.value); }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-center">Patient Email</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="email" className='customFieldForDence w-100' value={patientEmail} onInput={(e) => { setPatientEmail(e.target.value); }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Patient Mobile</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <input type="tel" className='customFieldForDence w-100' value={patientMobile} onInput={(e) => { setPatientMobile(e.target.value); }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Patient Address</div>
                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                <textarea className='customFieldForDence w-100' value={patientAddress} onInput={(e) => { setPatientAddress(e.target.value); }} style={{ maxWidth: "300px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col d-flex justify-content-end gap-3">
                                {/* <button
                                    type='button'
                                    className='btn btn-secondary px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                        // setItemsViewMode("View");
                                    }}>Back to All Items</button> */}
                                <input type="submit" value="Create" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className={`warrantyCertificateModal ${showWarrantyCertificate ? "d-flex" : "d-none"} flex-column overflow-auto`} >
                <div className='themeTextColor p-1 fw-bold text-center fs-3 upperMoonsSearchBackground'>
                    Warranty Certificate
                </div>
                <div className='w-100 p-5 bg-light rounded overflow-auto d-flex justify-content-xxl-center'>
                    <div className='border p-5 shadow align-self-start'>
                        <div id='WarrantyCardCertificate' style={{ width: "1420px", height: "1876px", backgroundImage: `url(${certificateImage})`, backgroundSize: "100% 100%", position: "relative" }}>
                            <span className='warrantyDetails warrantyNumberLocation'>{codeToSearch}</span>
                            <span className='warrantyDetails verificationNumberLocation'>{verificationCode}</span>
                            <span className='warrantyDetails labCaseNumberLocation'>{labCaseNumber}</span>
                            <span className='warrantyDetails yearsOfWarrantyLocation'>{yearOfWarranty}</span>
                            {
                                codeToSearch ?
                                    <Barcode
                                        value={codeToSearch}
                                        width={2}
                                        height={70}
                                        format="CODE39"
                                        displayValue={true}
                                        fontOptions="bold"
                                        font="monospace"
                                        // textAlign="center"
                                        textPosition="bottom"
                                        // textMargin={2}
                                        fontSize={40}
                                        background="#ffffff"
                                        lineColor="#000000"
                                        // margin={10}
                                        // marginTop=""
                                        // marginBottom=""
                                        // marginLeft=""
                                        // marginRight=""
                                        id=""
                                        className="warrantyDetails barcodeImageLocation"
                                    />
                                    :
                                    ""
                            }
                            <span className='warrantyDetails dateLocation'>{issueDate.split("T")[0].replaceAll("-", ".")}</span>
                            <span className='warrantyDetails productNameLocation'>{productName}</span>
                            <span className='warrantyDetails numberOfUnitLocation'>{quantity}</span>
                            <span className='warrantyDetails pointOfSupplyLocation'>{"Super-Admin"}</span>
                            <span className='warrantyDetails caseDescriptionLocation'>{labCaseDescription}</span>
                            <span className='warrantyDetails shadeDescriptionLocation'>{shadeDescription}</span>
                            <span className='warrantyDetails dentistNameLocation'>{dentistName}</span>
                            <span className='warrantyDetails dentistEmailLocation'>{dentistEmail}</span>
                            <span className='warrantyDetails dentistNumberLocation'>{dentistMobile}</span>
                            <span className='warrantyDetails dentistAddressLocation'>{dentistAddress}</span>
                            <span className='warrantyDetails patientNameLocation'>{patientName}</span>
                            <span className='warrantyDetails patientEmailLocation'>{patientEmail}</span>
                            <span className='warrantyDetails patientNumberLocation'>{patientMobile}</span>
                            <span className='warrantyDetails patientAddressLocation'>{patientAddress}</span>
                        </div>
                    </div>
                </div>
                <div className='w-100 d-flex justify-content-center gap-2 p-2 upperMoonsSearchBackground'>
                    <input type="button" value="Close" className='btn btn-secondary rounded-pill px-1 py-1 w-100' style={{ maxWidth: "150px" }} onClick={() => { setShowWarrantyCertificate(false) }} />
                    <button type="button" className='themeButtons rounded-pill px-1 py-1 w-100' style={{ maxWidth: "150px" }}
                        onClick={(e) => {
                            html2canvas(document.getElementById('WarrantyCardCertificate')).then(function (canvas) {
                                const pdf = new jsPDF({
                                    orientation: "portrait",
                                    unit: "px",
                                    compression: "NONE"
                                });
                                pdf.addImage(canvas.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, 446, 631);
                                pdf.save("file.pdf");
                            });
                        }}>
                        <DownloadIcon /> Download
                    </button>
                </div>
            </div>
        </>
    )
}
export default AddWarrantyCard